/**
 * Redux Saga Utils
 */
/* tslint:disable:space-before-function-paren */

import { effects as fx, SagaIterator } from 'redux-saga';
import { AsyncActionCreators } from 'typescript-fsa';
import { bindAsyncAction } from 'typescript-fsa-redux-saga';

export const sagaAsyncActionWorkerFactory = <P, R = IMutationResult, E = Error, PR = Promise<R>>(
  action: AsyncActionCreators<P, R, E>,
  asynFunc: (params: P, ...args) => PR,
) =>
  bindAsyncAction<P, R>(action)(
    function* (params: P, ...args): SagaIterator {
      return yield fx.call(asynFunc, params, ...args);
    },
  );



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/saga.ts